import { render, staticRenderFns } from "./AppBannerPreview.vue?vue&type=template&id=3b193134&scoped=true&functional=true"
var script = {}
import style0 from "./AppBannerPreview.vue?vue&type=style&index=0&id=3b193134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "3b193134",
  null
  
)

export default component.exports